//
// MaxRowsLookup.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var MaxRowsLookup = {
    NONE:0,
    LISTTABLE:1,
    CROSSTAB:2,
    BUTTONBAR:3,
    CUSTOMCONTENT:4,
    DROPDOWN:5,
    LIST:6,
    TEXTINPUT:7,
    GRAPHDEFAULT:8,
    BUBBLE:9,
    GEOBUBBLE:10,
    GEOCONTOUR:11,
    GEOSCATTER:12,
    GEOREGION:13,
    GEOHEATMAP:14,
    GEOLINE:15,
    HEATMAP:16,
    TIMESERIES:17,
    KPI:18,
    HEATBOX:19,
    DUALAXISTIMESERIES:20,
    SCATTER:21,
    TREEMAP:22,
    WORDCLOUD:23,
    KEYVALUE:24,
    GEOPIE:25
};
export default MaxRowsLookup;
